export const GET_ORDERS = 'GET_ORDERS';
export const CREATE_NEW_ORDER = 'CREATE_NEW_ORDER';
export const CHANGE_PAGE_NUMBER = 'CHANGE_PAGE_NUMBER';
export const CHANGE_INPUT_CREATE_ORDER = 'CHANGE_INPUT_CREATE_ORDER';

export const getOrders = (data) => dispatch =>
    dispatch({
        type: GET_ORDERS,
        payload: data
    });

export const createNewOrder = (data) => dispatch =>
    dispatch({
        type: CREATE_NEW_ORDER,
        payload: data
    });

export const changeInputCreateNewOrder = (data, event) => dispatch =>
    dispatch({
        type: CHANGE_INPUT_CREATE_ORDER,
        payload: data,
        event: event
    });

export const changePageNumber = () => dispatch =>
    dispatch({
        type: CHANGE_PAGE_NUMBER
    });
